// extracted by mini-css-extract-plugin
module.exports = {"carouselHeader":"feature-carousel-header_carouselHeader__jULGX"};